import { render, staticRenderFns } from "./setTemplate.vue?vue&type=template&id=5bd4c795&scoped=true"
import script from "./setTemplate.vue?vue&type=script&lang=js"
export * from "./setTemplate.vue?vue&type=script&lang=js"
import style0 from "./setTemplate.vue?vue&type=style&index=0&id=5bd4c795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4c795",
  null
  
)

export default component.exports